import { cn } from '@/lib/utils'

interface DividerProps {
  className?: string
  id?: string
}

export const Divider = ({ className, id }: DividerProps) => {
  return <hr className={cn(className, 'doss-divider my-5 mx-1')} id={id} />
}
